import { render, staticRenderFns } from "./SpecialtyCards.vue?vue&type=template&id=c86ebcca&scoped=true"
import script from "./SpecialtyCards.vue?vue&type=script&lang=js"
export * from "./SpecialtyCards.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyCards.vue?vue&type=style&index=0&id=c86ebcca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86ebcca",
  null
  
)

export default component.exports